<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-4 searching">
                        <span class="h_page">Copy Data Pendukung Penilaian</span> <br> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="row">
                    <div class="col-md-3">
                        <span>Tahun Data Pendukung Penilaian</span>
                    </div>
                    <div class="col-md-3">
                        <input type="text" class="form-control input-5">
                    </div>
                    <div class="col-md-6"></div>
                    <br> <br>
                </div>
                <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons">check</i>Proses</button>
                <hr>

                
        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {

    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
